import React from 'react'
import styled from 'styled-components'
import numeral from 'numeral'

import { criteria } from '../../../constants'
import { FONTS } from '../../../../../../../constants'

export const Total = React.memo(({ data, isExpand, allocation_id, handleExpandTable }) => {
  const { _sumTotalTypeRev = '0.00' } = data
  return (
    <Root>
      <StickyWrapper onClick={ () => handleExpandTable(allocation_id) }>
        <HeaderWrapper>
          <HeaderText>Total Type Rev</HeaderText>
          <HeaderNumber>{`฿ ${_sumTotalTypeRev}`}</HeaderNumber>
        </HeaderWrapper>
      </StickyWrapper>
      <StickyBody active={ isExpand }>
        { data.lobs.map((lob, key) => {
          const isMD = lob.criteria === criteria.MD

          return (
            <SummaryWrapper key={ key }>
              <PercentageCol>
                <HeaderText>{ isMD ? 'Total Mandays' : 'Total Percentage' }</HeaderText>
                <PercentageNumber
                  is_md={ isMD }
                  is_compelete={ numeral(lob._sumLobTotalRatio).value() <= 100 }
                >
                  {isMD ? lob._sumLobTotalRatio : `${lob._sumLobTotalRatio}%`}
                </PercentageNumber>
              </PercentageCol>
              <RevenueCol>
                <HeaderText>Total Revenue</HeaderText>
                <Number>{`฿ ${lob._sumLobTotalRevenue}`}</Number>
              </RevenueCol>
              <EmptyRow />
            </SummaryWrapper>
          )
        }
        )}
      </StickyBody>
    </Root>
  )
})

const Root = styled.div`
  margin-bottom: 8px;
`

const SummaryWrapper = styled.div`
  width: 140px;
  background: #FFFFFF;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: none;
`

const StickyWrapper = styled.div`
  height: 45px;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: none;
  border-bottom: none;
  background: #FFFFFF;
`

const StickyBody = styled.div`
  width: 140px;
  display: ${p => (p.active ? 'block' : 'none')};
`

const HeaderWrapper = styled.div`
  width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0 10px;
`

const PercentageCol = styled.div`
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 10px;
  padding-top: 12px;
`

const RevenueCol = styled.div`
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 10px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const HeaderNumber = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 12px;
  color: #1A1A17;
`

const Number = styled(HeaderNumber)`
  height: 30px;
  display: flex;
  align-items: center;
`

const PercentageNumber = styled(Number)`
  color: ${p => {
    if (p.is_md || p.is_compelete) return '#1A1A17'
    return '#F3B923'
  }};
`

const EmptyRow = styled.div`
  height: 40px;
  background: #FFFFFF;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/total/index.js